import { Group, Pill } from '@mantine/core'
import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Place, PremadeVariant } from 'types/products'
import { placeFilterFn } from 'utils'
import { sizeSortingFn, useProductTable } from './ProductTable'

type Props = {
  variants: Array<PremadeVariant>
  highlightItemId?: string
}

export default function PremadeTable({ variants, highlightItemId }: Props) {
  const columns = useMemo<Array<MRT_ColumnDef<PremadeVariant>>>(
    () => [
      {
        accessorKey: 'size',
        header: 'Wymiar',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wymiarze',
        },
        sortingFn: sizeSortingFn,
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'finish',
        header: 'Wykończenie',
        enableSorting: false,
        size: 150,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wykończeniu',
        },
        Cell: ({ cell }) => {
          const finishes = cell.getValue<Array<string>>()
          return (
            <Group gap="xs">
              {finishes.map((finish) => (
                <Pill key={finish}>{finish}</Pill>
              ))}
            </Group>
          )
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        filterFn: placeFilterFn,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po półce',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )
  const table = useProductTable({
    columns,
    data: variants,
    highlightItemId,
  })
  return <MantineReactTable table={table} />
}
